import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-view-tipo-movimiento',
  templateUrl: './dialog-view-tipo-movimiento.component.html',
  styleUrls: ['./dialog-view-tipo-movimiento.component.css']
})
export class DialogViewTipoMovimientoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
